import { Extension } from '@tiptap/core';
import { undo, redo } from 'prosemirror-history';

export const CustomHistory = Extension.create({
  name: 'customHistory',

  addCommands() {
    return {
      undo:
        () =>
        ({ tr, state, dispatch }) => {
          const result = undo(state, dispatch);
          if (result) {
            setTimeout(() => this.options.onCustomEvent());
          }
          return result;
        },

      redo:
        () =>
        ({ tr, state, dispatch }) => {
          const result = redo(state, dispatch);
          if (result) {
            setTimeout(() => this.options.onCustomEvent());
          }
          return result;
        }
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-z': () => this.editor.commands.undo(),
      'Mod-y': () => this.editor.commands.redo(),
      'Mod-shift-z': () => this.editor.commands.redo()
    };
  }
});
